import { Typography } from "@mui/material";

import ApiRequestErrorHandler from "../../../../global/ApiRequestErrorHandler";
import HNSColors from "../../../../ui library/HNSColors";
import { useCaseSearch } from "../../hooks/useCaseSearch";
import { useFetchAISummaryNote } from "../../hooks/useFetchAISummaryNote";
import { useAISummaryStore } from "../../store/aiSummaryStore";

import CallSummaryListItem from "./CallSummaryListItem";

export default function CallSummaryList({ data }) {
  const {
    setSelectedSummaryNote,
    showRightTopBar,
    setShowRightTopBar,
    setSelectedCase,
    setDisableCopyButton,
    setNavigationCaseId,
  } = useAISummaryStore();

  const { fetchCase } = useCaseSearch();

  const { fetchAISummaryNote } = useFetchAISummaryNote();

  const handleClick = async (item) => {
    try {
      setSelectedSummaryNote(item);
      const _case = await fetchCase(item?.caseId);
      setSelectedCase(_case);
      setNavigationCaseId(_case?.id);
      setDisableCopyButton(!_case);
      if (!showRightTopBar) {
        setShowRightTopBar?.(true);
      }
      fetchAISummaryNote(item?.uuid);
    } catch (error) {
      console.error(error);
      return ApiRequestErrorHandler(error);
    }
  };

  if (data && data.length === 0) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <Typography
          sx={{
            color: HNSColors.neutrals[500],
          }}
        >
          Nothing to show
        </Typography>
      </div>
    );
  }

  return (
    <div className="absolute bottom-0 top-0 flex w-full flex-col overflow-y-auto px-2 [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
      <div className="flex h-full flex-col gap-4">
        {data.map((item) => (
          <CallSummaryListItem key={item.id} data={item} handleClick={() => handleClick(item)} />
        ))}
      </div>
    </div>
  );
}
